<template>
  <div v-if="!isEmpty">
    <div class="d-flex">
      <div>
        <div>{{ startDate }}</div>
        <div class="text-center">
          <router-link
            :to="{ name: 'session-view', params: { id: training.id } }"
            class="link-small link-underline"
            >{{ $t('button.goTo') }}</router-link
          >
        </div>
      </div>
      <div>
        <event-icon :events-count="training.events_count"></event-icon>
        <comment-icon :training="training"></comment-icon>
      </div>
    </div>
  </div>
</template>

<script>
import CommentIcon from '@/components/Training/CommentIcon.vue'
import EventIcon from '@/components/Training/EventIcon.vue'
import { trainingDate } from '@/mixins/training-date'

export default {
  name: 'LastTrainingInfo',
  mixins: [trainingDate],
  components: {
    CommentIcon: CommentIcon,
    EventIcon: EventIcon
  },
  props: {
    training: {
      type: Object,
      required: true
    }
  },
  computed: {
    isEmpty() {
      return Object.keys(this.training).length === 0
    },
    startDate() {
      return this.getTrainingFormattedStartDate(this.training)
    }
  }
}
</script>
